module.exports = "/_next/static/images/bitcoin_full-919af8abcb3af0a9554a37d9d4a8e91c.png";